import { Component, inject, signal } from '@angular/core';
import { MainLayoutComponent } from '../../../_layouts/main-layout/main-layout.component';
import { ConfirmDialogComponent } from '../../../../Shared/_components/confirm-dialog/confirm-dialog.component';
import { CommonModule, DatePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { InvoiceService } from '../../../_services/invoice.service';
import { OrderService } from '../../../_services/order.service';
import { SiteSettings, SiteSettingsService } from '../../../_services/site-settings.service';
import { AlertService } from '../../../_services/alert.service';
import { Address } from '../../../_interfaces/address';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { postcodes } from './../../../../Shared/_constants/constants';
import { getStoneCladdingHandlingFee, isFullCrateFormat, getStoneCladdingLoads, isPavingProduct, isStoneCladdingProduct, stoneCladdingCartons } from '../delivery-rules';
import { TypeheadComponent } from '../../../../Shared/_components/typehead/typehead.component';
import { ProductService } from '../../../_services/product.service';
import { environment } from '../../../../../environments/environment';
import { BillingFormComponent } from  '../create-sale/partials/billing-form/billing-form.component';
import { CreateAddressModalComponent } from '../create-sale/partials/create-address-modal/create-address-modal.component';
import { UserService } from '../../../_services/users.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { CustomerTypeheadComponent } from '../create-sale/partials/customer-typehead/customer-typehead.component';
import { CouponService } from '../../../_services/coupon.service';
import { firstValueFrom } from 'rxjs';
import { AddEditCustomerComponent } from '../../customers/add-edit-customer/add-edit-customer.component';

@Component({
    selector: 'app-edit-sale',
    imports: [
        MainLayoutComponent,
        DatePipe,
        MatProgressSpinnerModule,
        FormsModule,
        RouterLink,
        MatIconModule,
        MatTooltipModule,
        NgClass,
        TypeheadComponent,
        CommonModule,
        BillingFormComponent,
        MatExpansionModule,
        CustomerTypeheadComponent
    ],
    templateUrl: './edit-sale.component.html',
    styleUrl: './edit-sale.component.css'
})
export class EditSaleComponent {
  order: any;
  editingOrderId: number | null | undefined;
  sendPayLinkProgress: boolean = false;
  payLinkCopied = false;
  billingAddress?: Address;
  shippingAdress?: Address;
  showEditForm: boolean = false;
  orderNote: string = '';
  orderNotes:any;
  readonly dialog = inject(MatDialog);
  readonly panelOpenState = signal(false);
  // Soft pill colours, same as the sales list.
  statusPill(status: string): string {
    switch (status) {
      case 'PROCESSING': return 'bg-green-50 text-green-700';
      case 'COMPLETED': return 'bg-emerald-100 text-emerald-800';
      case 'DELAYED COMPLETION': return 'bg-lime-100 text-lime-800';
      case 'VOID':
      case 'CHARGE BACK': return 'bg-stone-200 text-stone-700';
      case 'CANCELLED':
      case 'FAILED': return 'bg-red-50 text-red-700';
      case 'REFUNDED':
      case 'PARTIALLY REFUNDED': return 'bg-orange-100 text-orange-800';
      case 'PENDING': return 'bg-yellow-50 text-yellow-700';
      case 'ON HOLD':
      case 'PENDING COLLECTION': return 'bg-orange-50 text-orange-700';
      default: return 'bg-gray-100 text-gray-600';
    }
  }

  orderStatusToAvoidUpdate = ['PROCESSING',  'CANCELLED',  'COMPLETED', 'DELAYED COMPLETION', 'REFUNDED', 'PARTIALLY REFUNDED', 'VOID','CHARGE BACK'];
  refundType: string = 'FULL';
  adjustStock: boolean = false;
  refundReason: string = '';
  totalRefundAmount: number = 0;
  totalRefundedAmount: number = 0;
  refundItems:any = [];
  refundCustomStockAdjustmentAmt = 0;
  refuntCustomAmtErr:boolean = false;
  partiallyRefundAmtWithoutStock = 0;
  refundHistory:any;

  productsForCart:any  = [];
  subTotal = 0;
  netTotal = 0;
  vatAmount = 0;
  shipCost = 0;
  handleCharge = 0;
  totalDiscountedAmount = 0
  invalidPostcode = true;
  postCode = '';
  selectedDeliveryMethod: string = 'STANDARD';
  customerInfo: any;
  customerMode: string = 'CUSTOMER';
  appliedCouponCodes: any[] = [];
  redeemedDicounts: any[] = [];

  editingProduct: any;
  priceOnRequest: boolean = false;
  zoneNumber: string = '';
  deliveryType = '';
  selectedCustomer:any;
  defaultBillingAddress:any;
  defaultShippingAddress: any;
  sameAddress = true;

  loyaltyRedemptionError: any;
  loyaltyRedeemed = 0;
  loyaltyPoint: number = 0;

  productSuggestionList: { id: number; name: string; slug?: string, sku: string }[] = [];
  slabsCrates: any;
  areaCoverage: number = 0;
  frontEndURL = environment.frontEndURL;
  billingAddresses:any = [];
  shippingAddresses:any = [];
  agents:any = [];
  agent: number = 0;
  userVatNu: string = '';
  customers:any;
  modifyProducts: boolean = false;
  modifyCustomer: boolean = false;
  modifyDelivery: boolean = false;
  modifyAgent: boolean = false;
  modifyTracking: boolean = false;
  editCustVisible: boolean = true;
  editProductVisible: boolean = true;
  editDeliveryVisible: boolean = true;
  editAgentVisible: boolean = true;
  selectedTrackingMethod: string = 'NST TRACKING';
  selectedTrackingNumber: string = '';
  selectedTrackingStatus: string = 'NOT SHIPPED';
  couponError: any;
  enteredCouponCode:string = '';

  productSearchLoading: boolean = false;
  customerSearchLoading: boolean = false;

  modifyEmail: boolean = false;
  customerEmail: string = '';

  modifyBillingAddress: boolean = false;
  editAddress1: string = '';
  editAddress2: string = '';
  editCity: string = '';
  editCountry: string = '';
  editPostCode: string = '';
  editPhoneNo: string = '';

  modifyShippingAddress: boolean = false;
  editShipAddress1: string = '';
  editShipAddress2: string = '';
  editShipCity: string = '';
  editShipCountry: string = '';
  editShipPostCode: string = '';
  editShipPhoneNo: string = '';
  userInfo: any;
  isVatDiscounted  = false;

  constructor(
    private invoiceService: InvoiceService,
    private orderService: OrderService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private productService: ProductService,
    private userService: UserService,
    private couponService: CouponService,
    private siteSettingsService: SiteSettingsService,
  ) {}

  siteSettings: SiteSettings | null = null;

  // Delivery options for the edit dropdown: the ones switched on for the
  // back office, plus whatever the order already uses (it keeps that).
  get deliveryMethodOptions(): string[] {
    return ['STANDARD', 'EXPRESS', 'NEXTDAY', 'COLLECTION'].filter(
      (m) => m === this.order?.deliveryMethod || !this.siteSettings || this.siteSettingsService.isDeliveryEnabledInBackOffice(this.siteSettings, m),
    );
  }

  // False when refunds for this order's payment method are switched off in Site Settings.
  get gatewayRefundsEnabled(): boolean {
    return !this.siteSettings || !this.order || this.siteSettingsService.isRefundEnabled(this.siteSettings, this.order.paymentMethod);
  }

  // ---- Previous / next order in the list this one was opened from ----
  navigating = false;

  private get nav() {
    const nav = this.orderService.getOrderNav();
    if (!nav || !this.editingOrderId) return null;
    const idx = nav.orders.findIndex((o) => o.orderId === Number(this.editingOrderId));
    return idx < 0 ? null : { nav, idx };
  }

  // "3 of 78", counted across every page of the list.
  get navPosition(): { current: number; total: number } | null {
    const n = this.nav;
    return n ? { current: n.nav.pageIndex * n.nav.pageSize + n.idx + 1, total: n.nav.count } : null;
  }

  get hasPrevOrder(): boolean {
    const p = this.navPosition;
    return !!p && p.current > 1;
  }

  get hasNextOrder(): boolean {
    const p = this.navPosition;
    return !!p && p.current < p.total;
  }

  private get hasPendingEdits(): boolean {
    return (
      this.modifyProducts || this.modifyCustomer || this.modifyDelivery || this.modifyAgent ||
      this.modifyTracking || this.modifyBillingAddress || this.modifyShippingAddress ||
      this.modifyEmail || this.customerNoteDirty || (this.showEditForm && !!this.orderNote)
    );
  }

  goToOrder(direction: -1 | 1) {
    if (this.navigating || !this.nav) return;
    if (this.hasPendingEdits) {
      const ref = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Unsaved changes',
          message: 'You have changes on this order that are not saved. Move to another order and lose them?',
        },
      });
      ref.afterClosed().subscribe((result) => {
        if (result?.confirmation) this.stepOrder(direction);
      });
    } else {
      this.stepOrder(direction);
    }
  }

  private stepOrder(direction: -1 | 1) {
    const n = this.nav;
    if (!n) return;
    const { nav, idx } = n;
    const target = nav.orders[idx + direction];
    if (target) {
      this.openOrder(target);
      return;
    }
    // Off the end of this page: fetch the neighbouring page from the server.
    const pageIndex = nav.pageIndex + direction;
    if (pageIndex < 0 || pageIndex * nav.pageSize >= nav.count) return;
    this.navigating = true;
    this.orderService.getOrders({ ...nav.params, pageIndex, pageSize: nav.pageSize }).subscribe({
      next: (response: any) => {
        const orders = (response.orders ?? []).map((o: any) => ({ orderId: o.orderId, orderNo: o.orderNo }));
        if (!orders.length) {
          this.navigating = false;
          return;
        }
        this.orderService.setOrderNav({ ...nav, orders, pageIndex, count: response.count ?? nav.count });
        this.openOrder(direction === 1 ? orders[0] : orders[orders.length - 1]);
      },
      error: (error) => {
        this.navigating = false;
        this.alertService.alert(error?.error?.message || 'Could not load the next order', 'error');
      },
    });
  }

  private openOrder(order: { orderId: number; orderNo: string }) {
    this.navigating = true;
    this.orderService.setEditingOrderID(order.orderId, order.orderNo);
    this.router.navigate(['sales/reload'], { skipLocationChange: true });
  }

  // /sales/<order no>. The order id is normally already known (set by the
  // list); on a refresh or a pasted link it's looked up from the number.
  private routeOrderNo: string | null = null;

  ngOnInit(): void {
    this.siteSettingsService.get().subscribe((settings) => (this.siteSettings = settings));
    this.userInfo = this.userService.isLoggedIn();
    this.canCheckPayment = this.userService.isSuperAdmin();
    this.loadAgents();

    this.routeOrderNo = this.route.snapshot.paramMap.get('orderNo');
    let knownId: number | null = null;
    this.orderService.getEditingOrderID().subscribe((orderId) => (knownId = orderId)).unsubscribe();

    const known = knownId && (!this.routeOrderNo || this.orderService.getEditingOrderNo() === this.routeOrderNo);
    if (known) {
      this.editingOrderId = knownId;
      this.loadOrderData();
      return;
    }
    if (!this.routeOrderNo) {
      this.router.navigate(['sales']);
      return;
    }
    this.orderService.getOrderIdByNumber(this.routeOrderNo).subscribe({
      next: (found) => {
        this.orderService.setEditingOrderID(found.orderId, found.orderNo);
        this.editingOrderId = found.orderId;
        this.loadOrderData();
      },
      error: (error) => {
        this.alertService.alert(error?.error?.message || `Order ${this.routeOrderNo} not found`, 'error');
        this.router.navigate(['sales']);
      },
    });
  }

  onInvoiceDownload() {
    this.invoiceService.getInvoice(this.order, this.isVatDiscounted, this.totalRefundedAmount, this.refundHistory);
  }

  private async loadAgents() {
    await this.userService.getCustomers('SALES,SALEADMIN').subscribe({
      next: (response: any) => {
        this.agents = response;
      },
      error: (error: { error: { message: any; }; }) => this.alertService.alert(error.error.message, 'error'),
    });
  }

  // The customer's payment page for this order - same link the "send payment
  // link" email contains. frontEndURL is the site's /product/ address.
  get paymentLink(): string {
    if (!this.order?.encryptedId) return '';
    const site = new URL(environment.frontEndURL).origin;
    return `${site}/order-payment/${this.order.encryptedId}`;
  }

  async onCopyPaymentLink() {
    if (!this.paymentLink) return;
    try {
      await navigator.clipboard.writeText(this.paymentLink);
      this.payLinkCopied = true;
      this.alertService.alert('Payment link copied', 'success');
      setTimeout(() => (this.payLinkCopied = false), 2500);
    } catch {
      this.alertService.alert('Could not copy the link', 'error');
    }
  }

  onSendPaymentLink() {
    this.sendPayLinkProgress = true;
    this.orderService.sendPaymentLink(this.order.orderId).subscribe({
      next: (response) => {
        this.sendPayLinkProgress = false;
        this.alertService.alert('Payment link sent to customer', 'success');
      },
      error: (error) => {
        this.sendPayLinkProgress = false;
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

    onEmailOrder() {
    this.orderService.emailOrder(this.order.orderId, this.order.orderStatus).subscribe({
      next: (response) => {
        //window.location.replace(response?.sessionUrl);
        this.alertService.alert('Order details send to customer', 'success');
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }


  onStatusUpdate() {
    let modelConfig: any = {
      data: {
        title: 'Status change confirmation',
        message: 'Are you sure?',
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmation) {
        this.orderService
          .updateOrderStatus(this.order.orderId, this.order.orderStatus)
          .subscribe({
            next: (response) => {
              this.alertService.alert('Order status Updated', 'success');
              this.loadOrderData();
            },
            error: (error) => {
              this.alertService.alert(error.error.message, 'error');
            },
          });
      }
      else
        this.loadOrderData();
    });
  }

  onOrderNoteDelete(orderNoteId: number) {
    let modelConfig: any = {
      data: {
        title: 'Order note delete confirmation',
        message: 'Are you sure?',
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.confirmation) {
        this.orderService
          .deleteOrderNote(orderNoteId)
          .subscribe({
            next: (response) => {
              this.alertService.alert('Order note has been deleted', 'success');
              this.getOrderNotes();
            },
            error: (error) => {
              this.alertService.alert(error.error.message, 'error');
            },
          });
      }
    });
  }

  onOrderNoteCreation() {
    if (this.editingOrderId && this.orderNote !== '') {
      this.createOrderNote({
        orderId: this.editingOrderId,
        orderNote: this.orderNote,
      });
    }
  }

  onAdjustQuantityCheck(){
    if(this.adjustStock && this.refundType === 'FULL') {
      this.totalRefundAmount = this.order.netAmount - this.totalRefundedAmount;
    }

    if(!this.adjustStock && this.refundType === 'FULL') {
      this.totalRefundAmount = this.order.netAmount - this.totalRefundedAmount;
    }

    if(this.adjustStock && this.refundType === 'PARTIAL') {
      this.onCustomStockAdjustmentRefundAmt();
    }

    if(!this.adjustStock && this.refundType === 'PARTIAL') {
      this.onPartiallyRefundAmtChange();
    }
  }

  // The customer's own note on the order (it goes out on their order email).
  savedCustomerNote = '';
  savingCustomerNote = false;
  customerNoteJustSaved = false;

  get customerNoteDirty(): boolean {
    return (this.order?.orderNotes ?? '') !== this.savedCustomerNote;
  }

  onCustomerOrderNoteUpdate() {
    if (!this.customerNoteDirty || this.savingCustomerNote) return;
    this.updateCustomerOrderNote(this.order.orderId, this.order.orderNotes ?? '')
  }

  onRevertCustomerNote() {
    this.order.orderNotes = this.savedCustomerNote;
  }

  onRefundStockChanage(itemIndex: number) {
    const editingItem = this.refundItems[itemIndex];
    if (editingItem.refundQty > editingItem.originalQty) {
      this.refundItems[itemIndex].refundQty = 0;
      this.refundItems[itemIndex].refundAmt = 0;
    }else{
      this.refundItems[itemIndex].refundAmt = editingItem.unitPrice * editingItem.refundQty;
    }
    this.calculateRefundTotal();
  }

  onCustomStockAdjustmentRefundAmt() {
    const maxCustomAmt = this.order.netAmount - this.order.orderAmount;
    this.calculateRefundTotal();
    if( this.refundCustomStockAdjustmentAmt <= maxCustomAmt ) {
      this.totalRefundAmount += this.refundCustomStockAdjustmentAmt;
      this.refuntCustomAmtErr = false;
    }else {
      this.refuntCustomAmtErr = true;
    }
  }

  onPartiallyRefundAmtChange() {
    if(this.partiallyRefundAmtWithoutStock <= this.order.netAmount - this.totalRefundedAmount) {
      this.totalRefundAmount = this.partiallyRefundAmtWithoutStock;
    }else {
      this.partiallyRefundAmtWithoutStock = this.order.netAmount - this.totalRefundedAmount;
      this.totalRefundAmount = this.order.netAmount - this.totalRefundedAmount;
    }
  }

  // The delivery validation screen is for delivery staff and admins, and
  // only makes sense once the order has been placed and paid for.
  get canOpenDeliveryValidation(): boolean {
    const roles = String(this.userInfo?.userrole ?? '').split(',').map((r) => r.trim());
    const allowed = ['DELIVERY', 'ADMIN', 'SALEADMIN', 'S-ADMIN'].some((r) => roles.includes(r));
    return allowed && !['PENDING', 'PENDING COLLECTION', 'FAILED'].includes(this.order?.orderStatus);
  }

  // ---- Summary / products / notes helpers ----
  originLabel(origin: string | null | undefined): string {
    if (!origin) return '';
    const i = origin.indexOf('_cpc');
    return (i > 0 ? origin.substring(0, i) : origin).replace(/\.com$/i, '');
  }

  get agentName(): string {
    const id = Number(this.agent) || Number(this.order?.userId);
    return (this.agents ?? []).find((a: any) => a.userid === id)?.firstname ?? this.order?.agent?.firstname ?? '';
  }

  // Placed -> Paid -> Processing -> Completed, or where it ended up if it didn't get there.
  get orderSteps(): { label: string; done: boolean; date?: any; negative?: boolean }[] {
    const status = this.order?.orderStatus;
    const negative = ['CANCELLED', 'FAILED', 'VOID', 'CHARGE BACK'].includes(status);
    const processed = ['PROCESSING', 'DELAYED COMPLETION', 'COMPLETED', 'REFUNDED', 'PARTIALLY REFUNDED'].includes(status);
    const steps: { label: string; done: boolean; date?: any; negative?: boolean }[] = [
      { label: 'Placed', done: true, date: this.order?.orderDate },
      { label: 'Paid', done: !!this.order?.paymentDate, date: this.order?.paymentDate },
    ];
    if (negative) {
      steps.push({ label: String(status).charAt(0) + String(status).slice(1).toLowerCase(), done: false, negative: true });
      return steps;
    }
    steps.push({ label: 'Processing', done: processed });
    steps.push({ label: 'Completed', done: status === 'COMPLETED' });
    return steps;
  }

  get totalUnits(): number {
    return (this.productsForCart ?? []).reduce((sum: number, i: any) => sum + (Number(i.quantity) || 0), 0);
  }

  get totalWeightKg(): number {
    return (this.productsForCart ?? []).reduce((sum: number, i: any) => sum + (Number(i.weight) || 0) * (Number(i.quantity) || 0), 0);
  }

  // Order notes: staff notes vs. the automatic status / payment / tracking trail.
  showSystemNotes = true;

  noteKind(text: string | null | undefined): { key: string; icon: string; dot: string; card: string; system: boolean } {
    const t = String(text ?? '').trim().toLowerCase();
    if (t.startsWith('delivery notes')) return { key: 'delivery', icon: 'local_shipping', dot: 'bg-amber-500', card: 'bg-amber-50 border-amber-100', system: false };
    if (t.startsWith('status update')) return { key: 'status', icon: 'sync_alt', dot: 'bg-blue-500', card: 'bg-gray-50 border-gray-100', system: true };
    if (t.startsWith('payment ref') || t.startsWith('teya session') || t.includes('refund') || t.includes('paypal'))
      return { key: 'payment', icon: 'payments', dot: 'bg-emerald-500', card: 'bg-gray-50 border-gray-100', system: true };
    if (t.includes('tracking')) return { key: 'tracking', icon: 'local_shipping', dot: 'bg-sky-500', card: 'bg-gray-50 border-gray-100', system: true };
    return { key: 'note', icon: 'sticky_note_2', dot: 'bg-neutral-800', card: 'bg-white border-gray-200 shadow-sm', system: false };
  }

  // "Status Update: PROCESSING" -> "PROCESSING"
  noteStatus(text: string): string {
    return String(text ?? '').replace(/^status update:\s*/i, '').replace(/_/g, ' ').trim();
  }

  get visibleNotes(): any[] {
    const notes = this.orderNotes ?? [];
    return this.showSystemNotes ? notes : notes.filter((n: any) => !this.noteKind(n.orderNote).system);
  }

  // ---- Customer card helpers ----
  addressText(a: any): string {
    return [a?.address1, a?.address2, a?.city, a?.postCode, a?.country].filter(Boolean).join(', ');
  }

  mapsUrl(a: any): string {
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(this.addressText(a));
  }

  // Delivery address is the same as the billing one.
  get deliverySameAsBilling(): boolean {
    const b = this.billingAddress;
    const s = this.shippingAdress;
    if (!b || !s) return false;
    const norm = (v: any) => String(v ?? '').trim().toLowerCase();
    return (['address1', 'address2', 'city', 'postCode', 'country'] as const).every((k) => norm(b[k]) === norm(s[k]));
  }

  async copyText(text: string | null | undefined, label: string) {
    try {
      await navigator.clipboard.writeText(text ?? '');
      this.alertService.alert(`${label} copied`, 'success');
    } catch {
      this.alertService.alert('Could not copy - your browser blocked it', 'error');
    }
  }

  roundMoney(value: number): number {
    return Math.round(value * 100) / 100;
  }

  // Why the Refund button is off, if it is. onRefundOrder only goes ahead for
  // a full refund of exactly what's left, or a partial refund of less than
  // that - anything else used to fail silently after the confirmation.
  get refundBlockedReason(): string | null {
    const available = this.roundMoney(this.order.netAmount - this.totalRefundedAmount);
    const total = this.roundMoney(Number(this.totalRefundAmount) || 0);
    if (total <= 0) return 'Enter an amount or choose items to refund.';
    if (this.refundType === 'PARTIAL' && total >= available) {
      return 'A partial refund has to be less than what is left - use Full refund to refund all of it.';
    }
    if (this.refundType === 'PARTIAL' && this.refuntCustomAmtErr) {
      return "The total refund can't be more than the order total.";
    }
    return null;
  }

  onRefundClick() {
    let modelConfig: any = {
      data: {
        title: "Refund confirmation",
        message: "Are you sure you want to process this refund?"
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if(result?.confirmation) {
        this.onRefundOrder();
      }
    });
  }

  onRefundOrder() {
    if ((this.refundType === 'FULL' && this.totalRefundAmount == this.order.netAmount - this.totalRefundedAmount) || 
    (this.refundType === 'PARTIAL' && this.totalRefundAmount < this.order.netAmount - this.totalRefundedAmount)) {
      const refundItemsFormatted: any = [];
      this.refundItems.forEach((item: any) => {
        refundItemsFormatted.push({
          productVariantId: item.variantId,
          quantity: this.refundType === 'FULL' ? item.originalQty : item.refundQty,
          amount: this.refundType === 'FULL' ? item.originalQty * item.unitPrice : item.refundQty * item.unitPrice
        });
      });
      let refundParams  = {
        orderId: this.order.orderId,
        amount: Number(this.totalRefundAmount).toFixed(2),
        reason: this.refundReason,
        stockAdjusted: this.adjustStock,
        items: refundItemsFormatted
      }
      this.refundOrder(refundParams);
    }
  }

  private async refundOrder(params:any) {
    await this.orderService.refundOrder(params).subscribe(
      (response) => {
        this.loadOrderData();
        this.alertService.alert('Refund initiated', 'success');
      },
      (error) => {
        this.alertService.alert(error.error.message, 'error');
      }
    );
  }

  // private async getRefundHistory(orderId: number) {
  //   await this.orderService.getRefundOrder(orderId).subscribe(
  //     (response) => {
  //       this.refundHistory = response;
  //       console.log('Refund response:', response);
  //     },
  //     (error) => {
  //       this.alertService.alert(error.error.message, 'error');
  //     }
  //   );
  // }

  private async getRefundHistory(orderId: number): Promise<void> {
    await this.orderService.getRefundOrder(orderId).subscribe(
      (response: any[]) => {
        this.refundHistory = response;
        this.totalRefundedAmount = response.reduce(
          (sum, item) => sum + parseFloat(item.amount || '0'),
          0
        );
        this.totalRefundAmount = this.order.netAmount - this.totalRefundedAmount;
      },
      (error) => {
        this.alertService.alert(error.error.message, 'error');
      }
    );
  }

  private calculateRefundTotal() {
    if (this.adjustStock && this.refundType === 'PARTIAL') {
      this.totalRefundAmount = 0;
      this.refundItems.forEach((refundItem: any) => {
        this.totalRefundAmount += refundItem.refundAmt;
      });
    }
  }

  private async createOrderNote(params: {
    orderId: number;
    orderNote: string;
  }) {
    await this.orderService.createOrderNote(params).subscribe(
      (response) => {
        this.alertService.alert('Note created', 'success');
        this.showEditForm = false;
        this.orderNote = '';
        this.getOrderNotes();
      },
      (error) => {
        this.alertService.alert(error.error.message, 'error');
      }
    );
  }

  private async updateCustomerOrderNote(orderId: number, orderNote: string) {
    this.savingCustomerNote = true;
    await this.orderService.updateOrderCustomerNote(orderId, orderNote).subscribe(
      (response) => {
         this.savingCustomerNote = false;
         this.savedCustomerNote = orderNote;
         this.customerNoteJustSaved = true;
         setTimeout(() => (this.customerNoteJustSaved = false), 2500);
         this.alertService.alert("Customer order note updated", 'success');
         this.getOrderNotes();
      },
      (error) => {
         this.savingCustomerNote = false;
         this.alertService.alert(error.error.message, 'error');
      }
    );
  }

  private async getOrderNotes() {
    if (this.editingOrderId && this.editingOrderId !== null) {
      await this.orderService.getOrderNotes(this.editingOrderId).subscribe(
        (response) => {
          this.orderNotes = (response as any[]).sort((a, b) => {
            const dateDiff = new Date(b.orderNoteDate).getTime() - new Date(a.orderNoteDate).getTime();
            return dateDiff !== 0 ? dateDiff : b.id - a.id;
          });
        },
        (error) => {
          this.alertService.alert(error.error.message, 'error');
        }
      );
    }
  }

  private teyaVerifiedOrderId: number | null = null;

  // Teya's hosted checkout returns the browser here with no server callback,
  // and orders paid through a payment link keep their INVOICE method until the
  // payment is confirmed - so check with Teya once per order and reload.
  // The backend is a no-op when the order has no Teya session.
  private verifyTeyaPaymentIfPending() {
    if (
      this.order?.orderStatus !== 'PENDING' ||
      (this.order.paymentMethod !== 'TEYA' && this.order.paymentMethod !== 'INVOICE') ||
      this.teyaVerifiedOrderId === this.order.orderId
    ) {
      return;
    }
    this.teyaVerifiedOrderId = this.order.orderId;
    this.orderService.verifyTeyaPayment(this.order.orderId).subscribe({
      next: () => this.loadOrderData(),
      error: () => {},
    });
  }

  checkPaymentProgress: boolean = false;
  canCheckPayment: boolean = false;

  // ---- PayPal tracking check (super admins; same role as canCheckPayment) ----
  paypalTrackingCheck: any = null;
  paypalTrackingChecking = false;

  readonly paypalVerdicts: Record<string, { label: string; cls: string; icon: string; text: string }> = {
    match: { label: 'Confirmed at PayPal', cls: 'bg-emerald-50 border-emerald-200 text-emerald-800', icon: 'verified',
      text: 'PayPal holds this tracking number for the order. For own delivery PayPal keeps it at Shipped even after we send Delivered - that is the most PayPal accepts, so this order is fully up to date.' },
    'status-differs': { label: 'Status differs', cls: 'bg-amber-50 border-amber-200 text-amber-800', icon: 'sync_problem',
      text: "PayPal has this tracking number, but with a different status from ours - the last update didn't land, or it was changed in PayPal." },
    'different-number': { label: 'Different tracking at PayPal', cls: 'bg-amber-50 border-amber-200 text-amber-800', icon: 'sync_problem',
      text: "PayPal has tracking for this payment, but not under our tracking number - probably added by hand in PayPal." },
    missing: { label: 'Not at PayPal', cls: 'bg-red-50 border-red-200 text-red-800', icon: 'error',
      text: 'PayPal has no tracking for this payment, although we have sent it. Use the PayPal tracking catch-up in Site Settings to send it again.' },
    'not-sent-yet': { label: 'Not sent yet', cls: 'bg-gray-50 border-gray-200 text-gray-700', icon: 'schedule',
      text: 'Nothing has been sent to PayPal yet - it goes when the order is marked Completed or Delayed Completion.' },
    'no-payment-ref': { label: 'No payment ref', cls: 'bg-gray-50 border-gray-200 text-gray-700', icon: 'help',
      text: 'This order has no PayPal payment reference, so tracking cannot be sent or checked.' },
    error: { label: "Couldn't reach PayPal", cls: 'bg-red-50 border-red-200 text-red-800', icon: 'cloud_off',
      text: 'PayPal did not answer the check. Try again in a minute.' },
  };

  onVerifyPaypalTracking() {
    if (this.paypalTrackingChecking) return;
    this.paypalTrackingChecking = true;
    this.orderService.verifyPaypalTracking(this.order.orderId).subscribe({
      next: (r) => {
        this.paypalTrackingChecking = false;
        this.paypalTrackingCheck = r;
      },
      error: (error) => {
        this.paypalTrackingChecking = false;
        this.alertService.alert(error?.error?.message || 'Could not check PayPal tracking', 'error');
      },
    });
  }

  // Manual version of verifyTeyaPaymentIfPending: asks the backend to check
  // the order's Teya session, then reloads the order and reports whether the
  // payment was found.
  onCheckPayment() {
    this.checkPaymentProgress = true;
    this.orderService.verifyTeyaPayment(this.order.orderId).subscribe({
      next: () => {
        this.orderService.getOrderById(this.order.orderId).subscribe({
          next: (response: any) => {
            this.checkPaymentProgress = false;
            if (response.orderStatus !== this.order.orderStatus) {
              this.alertService.alert('Payment confirmed, order updated to ' + response.orderStatus, 'success');
              this.loadOrderData();
            } else {
              this.alertService.alert('No completed Teya payment found for this order yet', 'info');
            }
          },
          error: (error) => {
            this.checkPaymentProgress = false;
            this.alertService.alert(error.error.message, 'error');
          },
        });
      },
      error: (error) => {
        this.checkPaymentProgress = false;
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

  private async loadOrderData() {
    // A PayPal check belongs to the order it was run on.
    this.paypalTrackingCheck = null;
    if (this.editingOrderId && this.editingOrderId !== null) {
      await this.orderService
        .getOrderById(Number(this.editingOrderId))
        .subscribe(
          (response) => {
            this.order = response;
            // Opened without an order number in the address (e.g. straight
            // after creating a sale): show it there, without reloading.
            if (!this.routeOrderNo && this.order?.orderNo) {
              this.location.replaceState(`/sales/${this.order.orderNo}`);
            }
            this.savedCustomerNote = this.order.orderNotes ?? '';
            this.verifyTeyaPaymentIfPending();
            this.order.OrderCoupons.forEach((coupon: any) => {
              if (coupon.couponCode === 'VATEXEMP') {
                this.isVatDiscounted = true;
              }
            });
            this.totalRefundAmount = this.order.netAmount;
            this.loyaltyRedeemed = this.order.pointsUsed;
            this.selectedDeliveryMethod = this.order.deliveryMethod;
            this.selectedTrackingMethod = this.order.trackingMethod || 'NST TRACKING';
            this.selectedTrackingNumber = this.order.trackingNumber || '';
            this.selectedTrackingStatus = this.order.trackingStatus || 'NOT SHIPPED';
            this.userVatNu = this.order.vatNumber;
            this.selectedCustomer = null;
            if(this.order.customerId > 0) {
              this.getCustomerAddresses(this.order.customerId);
              this.customerMode = 'CUSTOMER';
            }
            else{
              this.customerMode = 'GUEST';
            }
            this.agent = this.order.userId;
            this.partiallyRefundAmtWithoutStock = this.order.netAmount;
            if (
              this.order?.OrderAddresses &&
              this.order?.OrderAddresses.length > 0
            ) {
              this.billingAddress = this.order?.OrderAddresses.find(
                (a: any) => a.addressType == 'BILLING'
              );
              this.customerEmail = this.billingAddress?.email || '';

              this.shippingAdress = this.order?.OrderAddresses.find(
                (a: any) => a.addressType == 'SHIPPING'
              );
              if (!this.shippingAdress) {
                this.shippingAdress = this.billingAddress;
                this.sameAddress = true;
              }
              else
                this.sameAddress = false;
              this.postCode = this.shippingAdress ? this.shippingAdress.postCode : '';
              if(this.order.customerId == 0){
                this.defaultBillingAddress = this.billingAddress;
                this.defaultShippingAddress = this.shippingAdress;
              }
            }
         
           
            this.refundItems = [];
            this.productsForCart = [];
            this.order.OrderItems.forEach((item:any) => {
              this.refundItems.push({
                variantId: item.variantId,
                unitPrice: item.unitPrice,
                originalQty: item.quantity,
                refundQty: 0,
                productName: item.productName,
                store: item.store,
                refundAmt: 0
              })

              let itemObj = {
                name: item.productName,
                sku: item.productSku,
                productId: item.productId,
                variantId: item.variantId,
                unitPrice: item.unitPrice,
                oldQuantity: item.quantity,
                quantity: item.quantity,
                onSale: item.onSale,
                categorySlug: item.categorySlug,
                categoryId: item.categoryId,
                parentId: item.parentId,
                isFullCrate: isFullCrateFormat(item.productFormat),
                weight: item.weight,
                deliveryTermSlug: item.productdterms,
                productFormat: item.productFormat,
                store: item.store,
              };
              this.productsForCart.push(itemObj);
            });
              if (
              this.order?.OrderCoupons &&
              this.order?.OrderCoupons.length > 0
            ) {
               this.validateCouponCodes(this.order?.OrderCoupons);
            }
            else{
                this.calculateShippingCost();
            }
            if(this.order && this.order.orderId) this.getOrderNotes();
            if (this.order && (this.order.orderStatus === 'REFUNDED' || this.order.orderStatus === 'PARTIALLY REFUNDED' || this.order.orderStatus === 'COMPLETED' || this.order.orderStatus === 'DELAYED COMPLETION')) this.getRefundHistory(this.order.orderId);
          },
          (error) => {
            this.alertService.alert(error.error.message, 'error');
          }
        );
    } else {
      this.router.navigate(['sales']);
    }
  }

  async validateCouponCodes(couponsList: any) {
    this.appliedCouponCodes = [];
    for (const coupon of couponsList) {
      await this.couponService.validateAndGetCouponCode(coupon.couponCode, this.customerInfo ? this.customerInfo.userid : 0, true).subscribe({
          next: (response) => {
            if (response) {
              let amount = 0;
    
              this.productsForCart.map((item: any) => {
                let itemAmount = 0;
                if(item.categorySlug == 'free-samples'){}
                else if(response.excludeSales && item.onSale){}
                else {
                  if(response.couponCategories.length > 0){
                    const catExcluded = response.couponCategories.filter(c => c.include == false && (c.categoryId == item.categoryId || c.categoryId == item.parentId));
                    if(catExcluded.length == 0){
                      const catIncluded = response.couponCategories.filter(c => c.include == true && (c.categoryId == item.categoryId || c.categoryId == item.parentId));
                      if(catIncluded.length > 0){
                        itemAmount = item.quantity * item.unitPrice;
                      }
                      else 
                        itemAmount = 0;
                    }
                    else 
                      itemAmount = 0;
                  }

                  if(response.couponProducts.length > 0){
                    const productExcluded = response.couponProducts.filter(c => c.include == false && c.productId == item.productId);
                    if(productExcluded.length == 0){
                      const productIncluded = response.couponProducts.filter(c => c.include == true && c.productId == item.productId);
                      if(productIncluded.length > 0){
                        itemAmount = item.quantity * item.unitPrice;
                      }
                      else 
                        itemAmount = 0;
                    }
                    else 
                      itemAmount = 0;
                  }
                  
                  if(response.couponCategories.length == 0 && response.couponProducts.length == 0 )
                    itemAmount = item.quantity * item.unitPrice;            
                }
                if(item.categorySlug !== 'free-samples') {
                  amount = amount + itemAmount;
                }
              });
              this.appliedCouponCodes.push({...response,amount});
              this.calculateShippingCost();
            } 
        },
        error: (error) => {
          //this.couponError = error.error.message;
        },
      });
    };
    
  }

  onCancelClick(){
    let modelConfig: any = {
      data: {
        title: "Delete confirmation",
        message: "Are you sure you want to cancel this Order?"
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if(result.confirmation) {
        this.cancelOrder();
      }
    });
  }

  async cancelOrder() {
    await this.orderService.cancelOrder(this.order.orderId).subscribe({
      next: (response) => {
        this.alertService.alert('Order cancelled successfully', 'success');
        this.loadOrderData();
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }


  calculateShippingCost() {
    let totalQty = 0;
    let slabWeight = 0;
    let aggWeight = 0;
    let stoneCladdingQty = 0;
    this.productsForCart.map((item: any) => {
      if (isPavingProduct(item.categorySlug, item.sku)) {
        if (item.isFullCrate) {
          totalQty += item.quantity;
        }
        else {
          slabWeight += item.quantity * item.weight;
        }
      }
      if (item.categorySlug == 'aggregates') {
        aggWeight +=  item.quantity * item.weight;
      }
      if (isStoneCladdingProduct(item.categorySlug))
        stoneCladdingQty += stoneCladdingCartons(item);
    });

    totalQty += (Math.ceil(slabWeight / 1000) + Math.ceil(aggWeight / 1000)) + getStoneCladdingLoads(stoneCladdingQty);
    let shippingCost = -1;
    let pCode = '';
    if (this.postCode) this.postCode = this.postCode.toUpperCase();
    postcodes.map((postcode) => {
      postcode.code.forEach((code) => {
        if (code.includes('|')){
          let codeSplit = code.split('|');
          let codePrefix = codeSplit[0];
          let rangeArr = codeSplit[1].split('-');
          for(let i = Number(rangeArr[0]); i <= Number(rangeArr[1]); i++){
            let newCode = codePrefix + i.toString();
            if (this.postCode?.startsWith(newCode) && newCode.length > pCode.length ) {
              pCode = newCode;
              if(postcode.priceOnRequest)
                shippingCost = 0;
              else
                shippingCost = postcode.amount;
              this.zoneNumber = postcode.zone;
              this.priceOnRequest = postcode.priceOnRequest;
            }
          }
        }
        else{
          if (this.postCode?.startsWith(code) && code.length > pCode.length ) {
            pCode = code;
            if(postcode.priceOnRequest)
              shippingCost = 0;
            else
              shippingCost = postcode.amount;
            this.zoneNumber = postcode.zone;
            this.priceOnRequest = postcode.priceOnRequest;
          }
        }
      });
    });
   
  
    if (shippingCost == -1) {
      this.shipCost = 0;
      this.invalidPostcode = true;
      this.zoneNumber = '';
      //this.alertService.alert('Invalid Postcode!', 'error');
    } else {
      this.invalidPostcode = false;
      if (this.selectedDeliveryMethod !== 'COLLECTION')
        this.shipCost = totalQty * shippingCost;
    }

    if (totalQty > 0) {
      switch (this.selectedDeliveryMethod) {
        case 'EXPRESS':
          this.shipCost +=
            totalQty * (this.customerInfo ? this.customerInfo.expressDeliveryCost : 30);
          break;
        case 'NEXTDAY':
          this.shipCost +=
            totalQty * (this.customerInfo ? this.customerInfo.nextDayDeliveryCost : 50);
          break;
        case 'COLLECTION':
          this.shipCost = 0;
          break;
      }
    } else {
      this.shipCost = 0;
    }
    this.updateDiscountsAutomated();
  }

  async updateDiscountsAutomated() {
    this.redeemedDicounts = [];
    let freeSampleAmt = 0;
    let accessoryAmt = 0;
    let pavingAmt = 0;
    let pavingCollectionQty = 0;
    let accessoryDisc = 0;
    let pavingDisc = 0;
    let pavingCollectionDisc = 0;
    let pavingSplitQty = 0;
    let fencingQty = 0;
    let deckingQty = 0;

    this.subTotal = 0;
    let pavingFound = false;
    let deckingFound = false;
    let stoneCladdingQty = 0;
    this.handleCharge = 0;

    for(let i = 0; i < this.productsForCart.length; i++) {
      const item = this.productsForCart[i];
      this.subTotal += item.unitPrice * item.quantity;

      if (isPavingProduct(item.categorySlug, item.sku)) 
        pavingFound = true;
      if((item.categorySlug == 'composite-fencing' || item.categorySlug == 'composite-decking'
        || item.categorySlug == 'landscaping-and-outdoor'  
      ) && [405, 636].indexOf(item.productId) < 0) {
        deckingFound = true;
      }

      if (isStoneCladdingProduct(item.categorySlug))
        stoneCladdingQty += stoneCladdingCartons(item);

      if([497, 411].indexOf(item.productId) >= 0 && item.sku.indexOf('WITHOUT') >= 0){
          if(item.weight * item.quantity < 36)
            this.handleCharge += 50;
          else if(item.weight * item.quantity < 86)
            this.handleCharge += 85;
          else if(item.weight * item.quantity < 151)
            this.handleCharge += 120;      
          else if(item.weight * item.quantity > 150)
            this.handleCharge += 180;
      }

      if (this.customerInfo?.userrole == 'TRADER') {
        if (item.categorySlug == 'free-samples') {
          freeSampleAmt += item.unitPrice * item.quantity;
        } else if (item.categorySlug == 'accessories') {
          accessoryAmt += item.unitPrice * item.quantity;
        } else {
          if (
            isPavingProduct(item.categorySlug, item.sku)||
            item.categorySlug == 'composite-fencing' || 
            item.categorySlug == 'composite-decking' 
          ) {
            if (item.isFullCrate) {
              if (item.onSale == false && item.categorySlug !== 'composite-fencing' && item.categorySlug !== 'composite-decking')
                pavingAmt += item.unitPrice * item.quantity;
              if (this.selectedDeliveryMethod == 'COLLECTION' && isPavingProduct(item.categorySlug, item.sku))
                pavingCollectionQty += item.quantity;
              if (item.categorySlug == 'composite-fencing' && [497, 411, 405, 636].indexOf(item.productId) < 0)
                fencingQty += (item.quantity * item.weight) / 200;
              else if (item.categorySlug == 'composite-decking' && [497, 411, 405, 636].indexOf(item.productId) < 0)
                deckingQty += (item.quantity * item.weight) / 200;
            } else {
              if (item.onSale == false && item.categorySlug !== 'composite-fencing' && item.categorySlug !== 'composite-decking')
                pavingAmt += item.unitPrice * item.quantity;
              pavingSplitQty += (item.quantity * item.weight) / 1000;
            }
          }
        }
      } else {
        if (item.categorySlug == 'free-samples') {
          if(this.customerMode == 'GUEST'){
            try {
              const response: any = await firstValueFrom(this.orderService.verifySample(this.defaultBillingAddress.email,this.defaultBillingAddress.phoneNo,this.defaultBillingAddress.postCode,this.order?.orderId));
              if (response && response.sample === false) {
                if (item.unitPrice > freeSampleAmt) freeSampleAmt = Number(item.unitPrice);
              }
            } catch (error: any) {
              this.alertService.alert(error.message, 'error');
            }
          }
          else if (this.customerInfo?.freeSample || this.customerInfo?.freeSampleOrderId == this.order.orderId) {
            if (item.unitPrice > freeSampleAmt)
              freeSampleAmt = Number(item.unitPrice);
          }
        } else if (
          isPavingProduct(item.categorySlug, item.sku)||
          item.categorySlug == 'composite-fencing' ||
          item.categorySlug == 'composite-decking'
        ) {
          if (item.isFullCrate) {
            if (this.selectedDeliveryMethod == 'COLLECTION' && isPavingProduct(item.categorySlug, item.sku))
              pavingCollectionQty += item.quantity;
            if (item.categorySlug == 'composite-fencing' && [497, 411, 405, 636].indexOf(item.productId) < 0)
              fencingQty += (item.quantity * item.weight) / 200;
            else if (item.categorySlug == 'composite-decking' && [497, 411, 405, 636].indexOf(item.productId) < 0)
              deckingQty += (item.quantity * item.weight) / 200;
          } else {
            pavingSplitQty += (item.quantity * item.weight) / 1000;
          }
        }
      }
    };

     this.deliveryType = '';
    if(this.selectedDeliveryMethod !== 'COLLECTION'){
      if(pavingFound || deckingFound || stoneCladdingQty > 0){
        if(pavingFound || stoneCladdingQty > 0){
          if(this.zoneNumber == '0')
            if(deckingFound)
              this.deliveryType = 'Kerbside Delivery' ;
            else
              this.deliveryType = 'Kerbside Delivery - FREE' ;
          else if(this.zoneNumber == '1')
            this.deliveryType = 'Price On Request' ;
          else
            this.deliveryType = 'Kerbside Delivery - Zone ' + this.zoneNumber + ' Surcharge';
        }

        if(deckingFound && this.zoneNumber !== '1'){
          if(this.deliveryType == '')
            this.deliveryType = '2 Man Delivery';
          else
            this.deliveryType = this.deliveryType + ' - 2 Man Delivery';
        }
      }
      else
        this.deliveryType = 'FREE DELIVERY' ;
    }

    if (
      accessoryAmt > 0 ||
      pavingAmt > 0 ||
      pavingCollectionQty > 0 ||
      freeSampleAmt > 0
    ) {
      pavingCollectionDisc =
        pavingCollectionQty *
        (this.customerInfo ? this.customerInfo.pavingCollectionDisc : 35);
      pavingDisc = (pavingAmt * this.customerInfo?.pavingDiscPerc) / 100;
      accessoryDisc = (accessoryAmt * this.customerInfo?.accessoryDiscPerc) / 100;

      if (freeSampleAmt > 0) {
        this.redeemedDicounts.push({
          code: 'free-samples',
          title: 'Free Sample Discount',
          discountedAmount: freeSampleAmt,
        });
      }

      if (accessoryDisc > 0 && !this.isTradeDiscountExludeCouponsAvailable()) {
        this.redeemedDicounts.push({
          code: 'accessories',
          title: 'Accessory Discount',
          discountedAmount: accessoryDisc,
        });
      }

      if (pavingDisc > 0 && !this.isTradeDiscountExludeCouponsAvailable()) {
        this.redeemedDicounts.push({
          code: 'trade',
          title: 'Trade Discount',
          discountedAmount: pavingDisc,
        });
      }

      if (pavingCollectionDisc > 0) {
        this.redeemedDicounts.push({
          code: 'collection',
          title: 'Collection Order Discount',
          discountedAmount: pavingCollectionDisc,
        });
      }
    } else {
      pavingCollectionDisc = 0;
      pavingDisc = 0;
      accessoryDisc = 0;
      this.redeemedDicounts = [];
    }

    if (pavingSplitQty > 0) {
      if (this.selectedDeliveryMethod == 'COLLECTION')
        this.handleCharge +=
          Math.ceil(pavingSplitQty) *
          (this.customerInfo ? this.customerInfo.handleFeeCollection : 45);
      else
        this.handleCharge +=
        Math.ceil(pavingSplitQty) *
          (this.customerInfo ? this.customerInfo.handleFeeDelivery : 85);
    } 

    if (fencingQty > 0) {
      if (this.selectedDeliveryMethod == 'COLLECTION')
        this.handleCharge +=
          Math.ceil(fencingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeCollectionFencing : 65);
      else
        this.handleCharge +=
        Math.ceil(fencingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeDeliveryFencing : 130);
    }

    if (deckingQty > 0) {
      if (this.selectedDeliveryMethod == 'COLLECTION')
        this.handleCharge +=
          Math.ceil(deckingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeCollectionFencing : 65);
      else
        this.handleCharge +=
        Math.ceil(deckingQty) *
          (this.customerInfo ? this.customerInfo.handleFeeDeliveryFencing : 130);
    }

    if (stoneCladdingQty > 0)
      this.handleCharge += getStoneCladdingHandlingFee(stoneCladdingQty);

    this.updateDiscountsOnCoupons();
    this.calculateSubTotal();
  }

  private updateDiscountsOnCoupons() {
    if (this.appliedCouponCodes) {
      this.appliedCouponCodes.forEach((ccode) => {
        let discountAmount = ccode.couponPerc ? ((ccode.amount * ccode.couponValue) / 100) : Number(ccode.couponValue);
        this.redeemedDicounts.push({
          code: ccode.couponCode,
          title:
            "Coupon code '" +
            ccode.couponCode +
            "' applied for '" +
            ccode.couponValue +
            (ccode.couponPerc ? "%'" : "£'") + " discount",
          discountedAmount: discountAmount,
        });
      });
    }
  }

  private isTradeDiscountExludeCouponsAvailable() {
    let available = false;
    if (this.appliedCouponCodes) {
      this.appliedCouponCodes.forEach((ccode) => {
        if(ccode.invalidateTradeDiscounts) available = true;
      });
    }
    return available;
  }

  
  private calculateSubTotal() {
    let totalDiscountedAmount = 0;
    if (this.redeemedDicounts.length > 0) {
      this.redeemedDicounts.forEach((disc: any) => {
        totalDiscountedAmount += disc.discountedAmount;
      });
    }
    totalDiscountedAmount += this.loyaltyRedeemed;

    this.totalDiscountedAmount = totalDiscountedAmount;
    //this.vatAmount = this.subTotal / 6;
    this.netTotal = this.subTotal - totalDiscountedAmount;
    this.netTotal += this.shipCost + this.handleCharge;
  }
  
  // Matches the storefront's cartService.verifyPavingProduct() - this
  // back-office's own CartService doesn't carry that helper, so the check
  // is inlined here instead.
  private isPavingProduct(categorySlug: string, sku: string): boolean {
    return isPavingProduct(categorySlug, sku);
  }

  // Mirrors the storefront's cart-removal guard: can't remove a product
  // while an accessory elsewhere in the basket ("With Paving"/"With
  // Fencing"/"With Decking"/"With Panels") still depends on it being there.
  private checkCanRemoveItem(item: any, cartItems: any[], currentTotal: number): string | null {
    const itemPrice = item.unitPrice * item.quantity;
    if (this.isPavingProduct(item.categorySlug, item.sku)) {
      const pavingAccCount = cartItems.filter((i: any) => i.name?.indexOf('With Paving') >= 0 && !i.isGiveAway).length;
      const pavingCount = cartItems.filter((i: any) => this.isPavingProduct(i.categorySlug, i.sku)).length;
      if (pavingAccCount > 0 && pavingCount == 1) {
        return "Please remove the paving acceessory 'With Paving' first!!";
      }
    } else if (item.categorySlug?.indexOf('fencing') >= 0 && item.name?.indexOf('Panel Kit') >= 0) {
      const fencingAccCount = cartItems.filter((i: any) => i.name?.indexOf('With Fencing') >= 0 && !i.isGiveAway).length;
      const fencingCount = cartItems.filter((i: any) => i.categorySlug?.indexOf('fencing') >= 0 && i.name?.indexOf('Panel Kit') >= 0).length;
      if (fencingAccCount > 0 && fencingCount == 1) {
        return "Please remove the fencing acceessory 'With Fencing' first!!";
      }
    } else if (item.categorySlug?.indexOf('decking') >= 0 && item.name?.indexOf('3D Embossed') >= 0) {
      const deckingAccCount = cartItems.filter((i: any) => i.name?.indexOf('With Decking') >= 0 && !i.isGiveAway).length;
      const deckingCount = cartItems.filter((i: any) => i.categorySlug?.indexOf('decking') >= 0 && i.name?.indexOf('End Cover') >= 0).length;
      if (deckingAccCount > 0 && deckingCount == 1) {
        return "Please remove the decking acceessory 'With Decking' first!!";
      }
    }

    const wallPanelAdhesCount = cartItems.filter((i: any) => i.name?.indexOf('With Panels') >= 0 && !i.isGiveAway).length;
    if (item.categorySlug !== 'wall-panel-adhesive-sealant' && wallPanelAdhesCount > 0 && currentTotal - itemPrice < 88) {
      return "Please remove the wall panel adhesive 'With Panels' first!!";
    }
    return null;
  }

  onCartItemRemoval(i: number) {
    const item = this.productsForCart[i];
    const removalError = this.checkCanRemoveItem(item, this.productsForCart, this.subTotal);
    if (removalError) {
      this.alertService.alert(removalError, 'error');
      return;
    }
    this.productsForCart.splice(i, 1);
    this.validateCouponCodes(this.appliedCouponCodes)
    this.calculateShippingCost();
  }

  onQuantityChange(i: number, type: string) {
    const item = this.productsForCart[i];
    if (item.quantity <= 1 && type === 'decrease') return;
    if (type === 'increase') {
      item.quantity += 1;
    } else if (type === 'decrease') {
      item.quantity -= 1;
    }
    this.productsForCart[i] = item;
    this.validateCouponCodes(this.appliedCouponCodes);
    this.calculateShippingCost();
  }

  // Some accessories (e.g. paving/fencing/decking adhesives) carry a
  // "With X"/"Without X" format option - "With X" only makes sense if the
  // matching product is actually in the basket already. Mirrors the same
  // guard on the storefront's product page so staff can't build an order
  // the live site itself wouldn't allow.
  private checkAccessoryDependencies(format: string): string | null {
    if (!format) return null;
    if (format.indexOf('With Paving') >= 0) {
      const pavingFound = (this.productsForCart ?? []).some((item: any) => this.isPavingProduct(item.categorySlug, item.sku));
      if (!pavingFound) return "No Paving products found in the basket, please change to 'Without Paving' option!";
    }
    if (format.indexOf('With Fencing') >= 0) {
      const fencingFound = (this.productsForCart ?? []).some((item: any) => item.categorySlug?.indexOf('fencing') >= 0 && item.name?.indexOf('Panel Kit') >= 0);
      if (!fencingFound) return "No Fencing products found in the basket, please change to 'Without Fencing' option!";
    }
    if (format.indexOf('With Decking') >= 0) {
      const deckingFound = (this.productsForCart ?? []).some((item: any) => item.categorySlug?.indexOf('decking') >= 0 && item.name?.indexOf('3D Embossed') >= 0);
      if (!deckingFound) return "No Decking products found in the basket, please change to 'Without Decking' option!";
    }
    if (format.indexOf('With Panels') >= 0) {
      if ((this.subTotal ?? 0) <= 88) return "Order amount should be >= 88 for selecting 'With Panels' option, please change to 'Without Panels' option!";
    }
    return null;
  }

  onAddToCart(cartItem: any) {
    if(cartItem.quantity <=0 )
    {
      this.alertService.alert("Invalid quantity!!", 'error');
      return;
    }
    if(cartItem.mStockQty < cartItem.quantity && cartItem.kStockQty < cartItem.quantity)
    {
      this.alertService.alert("Stock quantity is not sufficient!!", 'error');
      return;
    }

    const accessoryError = this.checkAccessoryDependencies(cartItem.format);
    if (accessoryError) {
      this.alertService.alert(accessoryError, 'error');
      return;
    }

    switch (this.editingProduct.product.productTemplateId) {
      case 1:
        let productName = cartItem.format
          ? this.editingProduct.product.productName + '-' + cartItem.format
          : this.editingProduct.product.productName;
        let itemObj = {
          name: productName,
          sku: cartItem.sku,
          productId: cartItem.productId,
          variantId: cartItem.productVariantId,
          unitPrice:
          cartItem.discPrice > 0
              ? cartItem.discPrice
              : cartItem.price,
          quantity: cartItem.quantity,
          oldQuantity: 0,
          onSale: cartItem.discPrice > 0 ? true : false,
          categorySlug:
          this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category.categorySlug
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categorySlug,
          categoryId: this.editingProduct.product.productcategories[0].category.categoryId,
          parentId:  this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category.categoryId
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categoryId,
          isFullCrate: isFullCrateFormat(cartItem.format),
          weight: cartItem.weight,
          deliveryTermSlug: cartItem.deliveryterm?.deliveryTermSlug,
          productFormat: cartItem.format
        };
        const existingItem1 = this.productsForCart.find(
          (cItem: any) => cItem.sku === itemObj.sku && cItem.unitPrice === itemObj.unitPrice
        );
        if (existingItem1) {
          if (cartItem.mStockQty < itemObj.quantity + existingItem1.quantity && cartItem.kStockQty < itemObj.quantity + existingItem1.quantity) {
            this.alertService.alert("Quantity requested is geater than available stock!", 'error');
            return;
          }
          existingItem1.quantity += itemObj.quantity;
        } else {
          this.productsForCart.push(itemObj);
        }
        break;
      case 2:
        let itemObjCrate = {
          name: this.editingProduct.product.productName + '- ' + cartItem.slabType,
          sku: cartItem.sku,
          productId: cartItem.productId,
          variantId: cartItem.productVariantId,
          unitPrice:
            cartItem.discPrice > 0
              ? cartItem.discPrice
              : cartItem.price,
          quantity: cartItem.quantity,
          oldQuantity: 0,
          onSale: cartItem.discPrice > 0 ? true : false,
          categorySlug:
            this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category
                  .categorySlug
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categorySlug,
          categoryId: this.editingProduct.product.productcategories[0].category.categoryId,
          parentId:  this.editingProduct.product.productcategories[0].category
              .categoryParentId == 0
              ? this.editingProduct.product.productcategories[0].category.categoryId
              : this.editingProduct.product.productcategories[0].category
                  .categoryParentIds.categoryId,
          isFullCrate: cartItem.slabType == 'CRATE',
          weight: cartItem.weight,
          deliveryTermSlug: cartItem.deliveryterm?.deliveryTermSlug,
          productFormat: cartItem.slabType
        };
        const existingItem2 = this.productsForCart.find(
          (cItem: any) => cItem.sku === itemObjCrate.sku && cItem.unitPrice === itemObjCrate.unitPrice
        );
        if (existingItem2) {
          if (cartItem.mStockQty < itemObjCrate.quantity + existingItem2.quantity && cartItem.kStockQty < itemObjCrate.quantity + existingItem2.quantity) {
            this.alertService.alert("Quantity requested is geater than available stock!", 'error');
            return;
          }
          existingItem2.quantity += itemObjCrate.quantity;
        } else {
          this.productsForCart.push(itemObjCrate);
        }
        break;
    }
    this.validateCouponCodes(this.appliedCouponCodes);
    this.calculateShippingCost();
  }
  
  onModifyProducts() {
    this.modifyProducts = true;
    this.editCustVisible = false;
    this.editDeliveryVisible = false;
    this.editAgentVisible = false;
    if(this.productSuggestionList.length == 0) {
      this.productSearchLoading = true;
      this.getAllProducts();
    }
  }

  onCancelChanges(){
    this.modifyProducts = false;
    this.editCustVisible = true;
    this.editDeliveryVisible = true;
    this.editAgentVisible = true;
    this.loadOrderData();
  }

  onModifyCustomer() {
    this.modifyCustomer = true;
    this.editProductVisible = false;
    this.editDeliveryVisible = false;
    this.editAgentVisible = false;
  }

  onCancelCustomerChanges(){
    this.modifyCustomer = false;
    this.editProductVisible = true;
    this.editDeliveryVisible = true;
    this.editAgentVisible = true;
    this.loadOrderData();
  }

  onModifyEmail() {
    this.modifyEmail = true;
  }

  onCancelEmailChanges() {
    this.modifyEmail = false;
  }

  onModifyBillingAddress() {
    this.editAddress1 = this.billingAddress?.address1 || '';
    this.editAddress2 = this.billingAddress?.address2 || '';
    this.editCity = this.billingAddress?.city || '';
    this.editCountry = this.billingAddress?.country || '';
    this.editPostCode = this.billingAddress?.postCode || '';
    this.editPhoneNo = this.billingAddress?.phoneNo || '';
    this.modifyBillingAddress = true;
  }

  onCancelBillingAddressChanges() {
    this.modifyBillingAddress = false;
  }

  async updateBillingAddress() {
    const newBillingAddress = {
      ...this.billingAddress,
      address1:  this.editAddress1,
      address2:  this.editAddress2,
      city:      this.editCity,
      country:   this.editCountry,
      postCode:  this.editPostCode,
      phoneNo:   this.editPhoneNo,
      addressType: 'BILLING',
    };

    const payload = {
      orderId:              this.order.orderId,
      productUpdate:        false,
      deliveryMethodUpdate: false,
      customerMode:         this.customerMode,
      customerId:           this.order.customerId,
      billingAddressId:     0,
      shippingAddressId:    0,
      customerBAddress:     newBillingAddress,
      customerSAddress:     this.shippingAdress ? { ...this.shippingAdress, addressType: 'SHIPPING' } : null,
      orderAmount:          this.order.orderAmount,
      discAmount:           this.order.discAmount,
      shipCost:             this.order.shipCost,
      handleCharge:         this.order.handleCharge,
      netAmount:            this.order.netAmount,
      deliveryTerms:        this.order.deliveryTerms,
      deliveryMethod:       this.order.deliveryMethod,
      deliveryType:         this.order.deliveryType,
      userpoints:           this.order.pointsUsed,
      vatNumber:            this.order.vatNumber,
      orderItems:           [],
      discountCoupons:      this.appliedCouponCodes,
      freeSample:           false,
    };

    this.orderService.updateOrder(payload).subscribe({
      next: () => {
        this.alertService.alert('Billing address updated successfully.', 'success');
        this.modifyBillingAddress = false;
        this.loadOrderData();
      },
      error: (error: any) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

  onModifyShippingAddress() {
    this.editShipAddress1 = this.shippingAdress?.address1 || '';
    this.editShipAddress2 = this.shippingAdress?.address2 || '';
    this.editShipCity     = this.shippingAdress?.city || '';
    this.editShipCountry  = this.shippingAdress?.country || '';
    this.editShipPostCode = this.shippingAdress?.postCode || '';
    this.editShipPhoneNo  = this.shippingAdress?.phoneNo || '';
    this.modifyShippingAddress = true;
  }

  onCancelShippingAddressChanges() {
    this.modifyShippingAddress = false;
  }

  async updateShippingAddress() {
    const newShippingAddress = {
      ...this.shippingAdress,
      address1:    this.editShipAddress1,
      address2:    this.editShipAddress2,
      city:        this.editShipCity,
      country:     this.editShipCountry,
      postCode:    this.editShipPostCode,
      phoneNo:     this.editShipPhoneNo,
      addressType: 'SHIPPING',
    };

    const payload = {
      orderId:              this.order.orderId,
      productUpdate:        false,
      deliveryMethodUpdate: false,
      customerMode:         this.customerMode,
      customerId:           this.order.customerId,
      billingAddressId:     0,
      shippingAddressId:    0,
      customerBAddress:     { ...this.billingAddress, addressType: 'BILLING' },
      customerSAddress:     newShippingAddress,
      orderAmount:          this.order.orderAmount,
      discAmount:           this.order.discAmount,
      shipCost:             this.order.shipCost,
      handleCharge:         this.order.handleCharge,
      netAmount:            this.order.netAmount,
      deliveryTerms:        this.order.deliveryTerms,
      deliveryMethod:       this.order.deliveryMethod,
      deliveryType:         this.order.deliveryType,
      userpoints:           this.order.pointsUsed,
      vatNumber:            this.order.vatNumber,
      orderItems:           [],
      discountCoupons:      this.appliedCouponCodes,
      freeSample:           false,
    };

    this.orderService.updateOrder(payload).subscribe({
      next: () => {
        this.alertService.alert('Shipping address updated successfully.', 'success');
        this.modifyShippingAddress = false;
        this.loadOrderData();
      },
      error: (error: any) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

  async updateEmail() {
    await this.orderService.updateOrderEmail(this.order.orderId,'BILLING', this.customerEmail).subscribe({
      next: (response) => {
        this.alertService.alert('Email Updated successfully.','success');
        this.modifyEmail = false;
        this.loadOrderData();
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

   onModifyDelivery() {
    this.modifyDelivery = true;
    this.editProductVisible = false;
    this.editCustVisible = false;
    this.editAgentVisible = false;
  }

  onCancelDeliveryChanges(){
    this.modifyDelivery = false;
    this.editProductVisible = true;
    this.editCustVisible = true;
    this.editAgentVisible = true;
    this.loadOrderData();
  }

  onModifyTracking() {
    this.modifyTracking = true;
  }

  onCancelTrackingChanges() {
    this.modifyTracking = false;
    this.selectedTrackingMethod = this.order.trackingMethod || 'NST TRACKING';
    this.selectedTrackingNumber = this.order.trackingNumber || '';
    this.selectedTrackingStatus = this.order.trackingStatus || 'NOT SHIPPED';
  }

  onSaveTracking() {
    this.orderService.updateOrderTracking(this.order.orderId, {
      trackingMethod: this.selectedTrackingMethod,
      trackingNumber: this.selectedTrackingNumber,
      trackingStatus: this.selectedTrackingStatus,
    }).subscribe({
      next: () => {
        this.alertService.alert('Tracking updated successfully.', 'success');
        this.modifyTracking = false;
        this.loadOrderData();
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

  onModifyAgent() {
    this.modifyAgent = true;
    this.editDeliveryVisible = false;
    this.editProductVisible = false;
    this.editCustVisible = false;
  }

  onCancelAgentChanges(){
    this.modifyAgent = false;
    this.editDeliveryVisible = true;
    this.editProductVisible = true;
    this.editCustVisible = true;
    this.loadOrderData();
  }

  async updateAgent(){
    if(this.agent) {
        await this.orderService.updateAgent(this.order.orderId, this.agent).subscribe({
      next: (response) => {
        this.alertService.alert('Agent Updated successfully.','success');
        this.modifyProducts = false;
        this.modifyCustomer = false;
        this.modifyDelivery = false;
        this.modifyAgent = false;
        this.editCustVisible = true;
        this.editProductVisible = true;
        this.editDeliveryVisible = true;
        this.editAgentVisible = true;
        this.loadOrderData();
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });   
    }
  }

  async saveOrder(productUpdate: boolean, deliveryMethodUpdate: boolean) {
    let totalDiscountedAmount = 0;
    let freeSample = this.customerInfo?.freeSample;
    let deckingFound = false;
    let freeSampleCount = 0;

    this.productsForCart.map((item: any) => {
      if((this.selectedDeliveryMethod == 'NEXTDAY' || this.selectedDeliveryMethod == 'EXPRESS' ) && (item.categorySlug == 'composite-fencing' || item.categorySlug == 'composite-decking'
        || item.categorySlug == 'landscaping-and-outdoor'))
         deckingFound = true;
      if (item.categorySlug == 'free-samples') {
          freeSampleCount += 1;
        }
    });

    if((this.selectedDeliveryMethod == 'NEXTDAY' || this.selectedDeliveryMethod == 'EXPRESS' ) && freeSampleCount == this.productsForCart.length) {
      this.alertService.alert('Selected Delivery method is not available for free sample products', 'error');
      return;
    }


    if(deckingFound){
      this.alertService.alert('Selected Delivery method is not available for decking/fencing/furniture products', 'error');
      return;
    }
    if (this.redeemedDicounts.length > 0) {
      this.redeemedDicounts.forEach((disc: any) => {
        if (disc.code == 'free-samples') freeSample = false;
        totalDiscountedAmount += disc.discountedAmount;
      });
    }
    totalDiscountedAmount += this.loyaltyRedeemed;
    let orderItems = productUpdate ?  this.productsForCart.map((item: any) => {
      return {
        productId: item.productId,
        variantId: item.variantId,
        unitPrice: Number(item.unitPrice),
        oldQuantity: item.oldQuantity,
        quantity: item.quantity,
        subTotal: item.quantity * item.unitPrice,
        productSku: item.sku,
        productName: item.name,
        productdterms: item.deliveryTermSlug ? `Estimated delivery is ${item.deliveryTermSlug.replace('Estimated delivery is ', '').replace(' working days', '')} working days` : '',
        productFormat: item.productFormat,
        weight: item.weight,
        onSale: item.onSale,
        categorySlug: item.categorySlug,
        categoryId: item.categoryId,
        parentId: item.parentId,
        store: 'Markstey'
      };
    }) : [];

    let minValue = 0;
    let maxValue = 0;
    let deliveryTerms = '';
    let hasInvalidDeliveryTerm = false;
    let oncallPresent = false;

    try{
        this.productsForCart.map((item: any) => {
          if(!item.deliveryTermSlug){
            hasInvalidDeliveryTerm = true;
            return;
          }
          let deliveryTermSlug = item.deliveryTermSlug.replace('Estimated delivery is ', '').replace(' working days', '');
          if (deliveryTermSlug === 'call') {
            oncallPresent = true;
            return;
          }
          let arr = deliveryTermSlug.split('-');
          const lo = Number(arr[0]);
          const hi = Number(arr[1]);
          // A malformed/non-numeric deliveryTermSlug produces NaN here.
          // Comparing NaN against minValue/maxValue is always false, so it
          // would otherwise be silently skipped rather than corrupting the
          // total - masking a broken item behind a confident-looking range
          // from the other, valid items.
          if (isNaN(lo) || isNaN(hi)) {
            hasInvalidDeliveryTerm = true;
            return;
          }
          if(lo < minValue || minValue == 0)
            minValue = lo;
          if(hi > maxValue || maxValue == 0)
            maxValue = hi;
        });

        deliveryTerms = `Estimated delivery is ${minValue} to ${maxValue} working days`
      }
      catch(e)
      {console.log(e)}

      
     if((this.selectedDeliveryMethod === 'EXPRESS' || this.selectedDeliveryMethod === 'NEXTDAY' || this.selectedDeliveryMethod === 'COLLECTION') && maxValue > 5){
        this.alertService.alert('Selected Delivery method is not available for products with delivery terms > 5days ', 'error');
        return;
      }

      if (oncallPresent) {
        this.alertService.alert('One of the items in this order is "on call" delivery - please contact the customer to arrange this before placing the order.', 'error');
        return;
      }

      // A product's delivery term couldn't be parsed into a valid day range
      // (missing, non-numeric, or malformed deliveryTermSlug) - don't let an
      // order go out with a meaningless "NaN to NaN"/"0 to 0" estimate, and
      // don't let a broken item hide behind a confident-looking range from
      // the other, valid items in the cart. Doesn't apply to Express/
      // Next-day/Collection, which override this text below regardless of
      // minValue/maxValue.
      if (
        this.selectedDeliveryMethod !== 'EXPRESS' &&
        this.selectedDeliveryMethod !== 'NEXTDAY' &&
        this.selectedDeliveryMethod !== 'COLLECTION' &&
        (hasInvalidDeliveryTerm || isNaN(minValue) || isNaN(maxValue) || minValue <= 0 || maxValue <= 0)
      ) {
        this.alertService.alert("One of the items in this order is missing a valid delivery estimate. Please check the product's delivery term before placing this order.", 'error');
        return;
      }


    if(this.selectedDeliveryMethod === 'EXPRESS')
      deliveryTerms = 'Estimated delivery is 2 to 3 working days';
    else if(this.selectedDeliveryMethod === 'NEXTDAY')
      deliveryTerms = 'Estimated delivery is the next working day for orders received before 11 AM';
    else if(this.selectedDeliveryMethod === 'COLLECTION')
      deliveryTerms = '';

    if(this.defaultBillingAddress) this.defaultBillingAddress.addressType = 'BILLING';
    if(this.defaultShippingAddress) this.defaultShippingAddress.addressType = 'SHIPPING';

    let orderData = {
      orderId: this.order.orderId,
      customerId: this.customerInfo && this.customerMode == 'CUSTOMER' ? this.selectedCustomer.userid : 0,
      orderAmount: this.subTotal,
      discAmount: totalDiscountedAmount,
      shipCost: this.shipCost,
      handleCharge: this.handleCharge,
      netAmount: this.netTotal,
      userpoints: this.loyaltyRedeemed,
      orderItems: orderItems,
      billingAddressId:  this.customerInfo && this.customerMode == 'CUSTOMER' && this.defaultBillingAddress ?  this.defaultBillingAddress.id : 0,
      shippingAddressId:
        this.customerInfo && this.customerMode == 'CUSTOMER' && this.defaultShippingAddress && !this.sameAddress
          ? this.defaultShippingAddress.id
          : 0,
      freeSample: freeSample,
      customerBAddress:
        this.customerMode == 'GUEST' && this.defaultBillingAddress
          ? this.defaultBillingAddress
          : null,
      customerSAddress:
        this.customerMode == 'GUEST' && !this.sameAddress && this.defaultShippingAddress
          ? this.defaultShippingAddress
          : null,
      deliveryTerms: deliveryTerms,
      deliveryMethod: this.selectedDeliveryMethod,
      customerMode: this.customerMode,
      discountCoupons: this.appliedCouponCodes,
      deliveryType: this.deliveryType, 
      productUpdate: productUpdate,   
      vatNumber: this.userVatNu,   
      deliveryMethodUpdate: deliveryMethodUpdate
    };
    await this.orderService.updateOrder(orderData).subscribe({
      next: (response) => {
        this.alertService.alert('Order Updated successfully.','success');
        this.modifyProducts = false;
        this.modifyCustomer = false;
        this.modifyDelivery = false;
        this.modifyAgent = false;
        this.editCustVisible = true;
        this.editProductVisible = true;
        this.editDeliveryVisible = true;
        this.editAgentVisible = true;
        this.loadOrderData();
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

   private getAllProducts() {
    this.productService.getSalesProductSuggestions().subscribe({
      next: (response) => {
        this.productSuggestionList = response ?? [];
        this.productSearchLoading = false;
      },
      error: (error: { error: { message: any } }) =>
        this.alertService.alert(error.error.message, 'error'),
    });
  }

    onProductSelection(selectedProd: {
    id: number;
    name: string;
    slug?: string;
  }) {
    if (selectedProd.slug) {
      this.getSelectedProduct(selectedProd.slug);
    }
  }

  private async getSelectedProduct(productSlug: string) {
    await this.productService.getProductBySlug(productSlug).subscribe({
      next: async (response) => {
        this.editingProduct = response;
        if (this.editingProduct) {
          this.editingProduct.variants = this.editingProduct.variants.filter((v: any) => v.trackQty == true);
          this.editingProduct.variants = this.editingProduct.variants.map(
            (variant: any) => {
              return { ...variant, quantity: 0, format: this.getFormat(variant),slabType: variant.sku.includes('SLAB') ? 'SLAB' :  variant.sku.includes('CRATE') ? 'CRATE' : '' };
            }
          );
          if (this.editingProduct.product.productTemplateId === 2) this.setSlabsCrates(this.editingProduct.variants);
        }
      },
      error: (error) => {
        this.alertService.alert(error.error.message, 'error');
      },
    });
  }

  private getFormat(variant: any) {
    let allAttrs = '';
    let attributes = this.editingProduct.attributes.filter(
      (att: any) => att.variants == true
    );
    for(let vd of variant.variantdetails){
      for(let attr  of attributes){
        let attrValue =  attr.attributevalues.find(
          (attv: any) => attv.id  == vd.productAttributeValueId
        );
        if(attrValue){
          allAttrs = allAttrs + (allAttrs == '' ? '' : ',')  + attrValue.productattributeName?.attributeValueSlug
        }
      }
    }
    return allAttrs;

  }


  private setSlabsCrates(variants: any) {
    this.slabsCrates = {
      slab: variants.find( (variant: any) => variant.format === 'Slab' ),
      crate: variants.find( (variant: any) => variant.format === 'Crate' ),
    }
  }

   onProductQuantityChange() {
    const coverageBySlabs = this.slabsCrates.slab.quantity * this.slabsCrates.slab.approxCoverage;
    const coverageByCrates = this.slabsCrates.crate.quantity * this.slabsCrates.crate.approxCoverage;
    this.areaCoverage = coverageByCrates + coverageBySlabs;
  }

   onAreaChange() {
    const numberOfSlabsNeed = this.areaCoverage / this.slabsCrates.slab.approxCoverage;
    if (numberOfSlabsNeed < this.slabsCrates.slab.approxCoverage) {
      this.slabsCrates.slab.quantity = Math.round(numberOfSlabsNeed);
    } else {
      let numberOfCratesRequired = numberOfSlabsNeed / this.slabsCrates.crate.approxTiles;
      numberOfCratesRequired = Math.trunc(numberOfCratesRequired);
      this.slabsCrates.crate.quantity = numberOfCratesRequired;
      const slabs = numberOfSlabsNeed - this.slabsCrates.crate.quantity * this.slabsCrates.crate.approxTiles;
      this.slabsCrates.slab.quantity = Math.round(slabs);
    }
  }

  onBillingFormSubmit(event:any) {
    this.defaultBillingAddress = event.billingAddress;
    this.defaultShippingAddress = event?.sameShippingAddress ? null : event.shippingAddress;
    this.postCode = event?.sameShippingAddress ? event.billingAddress.postCode : event.shippingAddress.postCode ;
    this.sameAddress =  event?.sameShippingAddress;
    this.calculateShippingCost();
  }

  onCustomerModeSelection(mode: string) {
    this.customerMode = mode;
    this.selectedCustomer = null;
    this.customerInfo = null;
  } 

  onCreateNewAddress(editingAddress?:any) {
    let modelConfig: any = {
      width: '75%',
      minHeight: '500px',
      data: {customerId: this.selectedCustomer.userid, isEdit: false},
    };
      if(editingAddress) {
      editingAddress.customerId = this.selectedCustomer? this.selectedCustomer.userid : editingAddress.userId;
      editingAddress.isEdit = true;
      modelConfig.data = editingAddress;
      }
    const dialogRef = this.dialog.open(CreateAddressModalComponent, modelConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        const alertMsg = editingAddress? 'Address updated!' : 'Adddress created!';
        this.alertService.alert(alertMsg, 'success');
        this.getCustomerAddresses(this.selectedCustomer.userid);
      }
    });
  }

  private async getCustomerAddresses(customerId: number) {
    await this.userService
      .getCustomerAddresses(
        customerId
      )
      .subscribe({
        next: (response) => {
          this.shippingAddresses = [];
           this.billingAddresses = [];
          response.forEach((addrs: any) => {
            if (addrs.addressType === 'BILLING') {
              this.billingAddresses.push(addrs);
              if(addrs.isDefault) this.defaultBillingAddress = addrs;
            }
            if (addrs.addressType === 'SHIPPING') {
              this.shippingAddresses.push(addrs);
              if(addrs.isDefault) this.defaultShippingAddress = addrs;
            }
            this.postCode = '';
            if (this.defaultShippingAddress && !this.sameAddress) {
              this.postCode = this.defaultShippingAddress?.postCode;
            } else {
              this.postCode = this.defaultBillingAddress?.postCode;
            }
          });
          if(this.editCustVisible && this.selectedCustomer?.useremail)
            this.getCustomerInfo(this.selectedCustomer.useremail);
          else
            this.getCustomerInfo(this.order.customer.useremail);
        },
        error: (error) => this.alertService.alert(error.error.message, 'error'),
      });
  }

  private async getCustomerInfo(email: string) {
    await this.userService
      .getCustomerInfo(
        email
      )
      .subscribe({
        next: (response) => {
          this.customerInfo = response;
          if(this.customerInfo){
            this.selectedCustomer = this.customerInfo;
            this.loyaltyPoint = this.customerInfo?.userpoints;
            this.calculateShippingCost();
          }
        },
        error: (error) => this.alertService.alert(error.error.message, 'error'),
      });
  }

   onAddressSelection(addrs: any) {
    this.postCode = '';
    if (addrs.addressType === 'BILLING') this.defaultBillingAddress = addrs;
    if (addrs.addressType === 'SHIPPING') this.defaultShippingAddress = addrs;
    if (this.defaultShippingAddress && !this.sameAddress) {
      this.postCode = this.defaultShippingAddress?.postCode;
    } else {
      this.postCode = this.defaultBillingAddress?.postCode;
    }
    this.calculateShippingCost();
  }

  onSamaddressChange(){
    this.postCode = '';
    if (this.sameAddress && this.billingAddresses.length > 0 && this.defaultBillingAddress)
      this.postCode = this.defaultBillingAddress?.postCode;
    if (!this.sameAddress && this.shippingAddresses.length > 0 && this.defaultShippingAddress) 
      this.postCode = this.defaultShippingAddress?.postCode;
    
    this.calculateShippingCost();
  }

  onCustomerSelection(selectedCustomer: any) {
    if (selectedCustomer && selectedCustomer.userid) {
      this.selectedCustomer = selectedCustomer;
      this.userVatNu = this.selectedCustomer?.vatnumber || '';

      this.resetAddresses();
      this.getCustomerAddresses(selectedCustomer.userid);
    }else {
      this.selectedCustomer = undefined;
      this.resetAddresses();
    }
  }

   private resetAddresses() {
    this.defaultBillingAddress = undefined;
    this.defaultShippingAddress = undefined;
    this.billingAddresses = [];
    this.shippingAddresses = [];
    this.sameAddress = true;
    this.postCode = '';
  }

  // The customer picker searches the server as you type (see
  // CustomerTypeheadComponent.searchFn), so no full customer list is loaded
  // when "Modify Customer" is opened.
  searchCustomers = (keyword: string) => this.userService.searchCustomers(keyword);

  onDeliveryMethodUpdate(){
    this.calculateShippingCost();
  }

  onRemoveCouponCode(item: any, index: number) {
    this.appliedCouponCodes.splice(index, 1);
    this.updateDiscountsAutomated();
    this.saveOrder(false,true)
  }

   async onApplyCouponCode() {
    let exists = false;
    let individualUse = false;

    this.appliedCouponCodes.map(coupon => {
      if(coupon.couponCode.toUpperCase() == this.enteredCouponCode.toUpperCase())
        exists = true;
      if(coupon.individualUse)
        individualUse = true;
    });

    if(exists){
      this.couponError = "Coupon code already added!!";
      return;
    }

    if(individualUse){
      this.couponError = "Already added Coupon code can't be used in conjuction with other coupons.";
      return;
    }

    await this.couponService.validateAndGetCouponCode(this.enteredCouponCode,this.customerInfo ? this.customerInfo.userid : 0, false).subscribe({
      next: (response) => {
        if (response) {
          if(response.individualUse && this.appliedCouponCodes.length > 0){
            this.couponError = "Coupon can't be used in conjuction with other coupons.";
            return;
          }

          if(response.minSpend && this.productsForCart.total < response.minSpend){
            this.couponError = `Cart total is less than minimum spend(£${response.minSpend})!`;
            return;
          }

          if(response.maxSpend && this.productsForCart.total > response.maxSpend){
            this.couponError = `Cart total is greater than maximum spend(£${response.maxSpend})!`;
            return;
          }

          const userType = this.customerInfo?.usertype || 'NONMEMBER';

            if(
              response.userRoles 
            ) {
              const allowedUsertypes = JSON.parse(response.userRoles);
              if (!allowedUsertypes.includes(userType)){
                this.alertService.alert('Invalid coupon code!', 'error');
                return;
              }
            }

          let amount = 0;
  
          this.productsForCart.map((item: any) => {
            let itemAmount = 0;
            if(item.categorySlug == 'free-samples'){}
            else if(response.excludeSales && item.onSale){}
            else {
              if(response.couponCategories.length > 0){
                const catExcluded = response.couponCategories.filter(c => c.include == false && (c.categoryId == item.categoryId || c.categoryId == item.parentId));
                if(catExcluded.length == 0){
                  const catIncluded = response.couponCategories.filter(c => c.include == true && (c.categoryId == item.categoryId || c.categoryId == item.parentId));
                  if(catIncluded.length > 0 || response.couponCategories.filter(c => c.include == true).length == 0){
                    itemAmount = item.quantity * item.unitPrice;
                  }
                  else 
                    itemAmount = 0;
                }
                else 
                  itemAmount = 0;
              }

              if(response.couponProducts.length > 0){
                const productExcluded = response.couponProducts.filter(c => c.include == false && c.productId == item.productId);
                if(productExcluded.length == 0){
                  const productIncluded = response.couponProducts.filter(c => c.include == true && c.productId == item.productId);
                  if(productIncluded.length > 0 || response.couponProducts.filter(c => c.include == true).length == 0){
                    itemAmount = item.quantity * item.unitPrice;
                  }
                  else 
                    itemAmount = 0;
                }
                else 
                  itemAmount = 0;
              }
               
              if(response.couponCategories.length == 0 && response.couponProducts.length == 0 )
                itemAmount = item.quantity * item.unitPrice;            
            }
            amount = amount + itemAmount;
          });

          if(amount == 0)
            this.couponError = "Coupon code not valid for cart items.";
          else{
            this.appliedCouponCodes.push({...response,amount});
            this.enteredCouponCode = '';
            this.couponError = undefined;
            this.updateDiscountsAutomated();
            this.saveOrder(false,true);
          }
        } else {
          this.couponError = 'Invalid coupon code!';
        }
      },
      error: (error) => {
        this.couponError = error.error.message;
      },
    });

   
  }
  get netBalance(): number {
    return this.netTotal - this.order.refundAmt;
  }

  onCreateCustomer() {
      let modelConfig: any = {
        width: '75%',
        minHeight: '500px',
      };
      const dialogRef = this.dialog.open(AddEditCustomerComponent, modelConfig);
      dialogRef.afterClosed().subscribe((result) => {
        if (result.status) {
          if(result.customer) { 
            this.onCustomerSelection(result.customer); 
          }
        }
      });
    }

}
